module.exports = __webpack_public_path__ + "media/images/riders/JULIEN_ABSALON-2205e93a19f1b743f2f21a6cbde384e1.png";